import { render, staticRenderFns } from "./TwoFactorAuthentication.vue?vue&type=template&id=2831ad1f&"
import script from "./TwoFactorAuthentication.vue?vue&type=script&lang=js&"
export * from "./TwoFactorAuthentication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports